import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {RouterLink} from "@angular/router";
import {Button, ButtonDirective} from "primeng/button";
import {UserService} from "../../services/user.service";
import {AuthService} from "../../services/auth/auth.service";
import {isNative} from "../../utils";

@Component({
  selector: 'footer[homeyFooter]',
    imports: [
    RouterLink,
    Button,
    ButtonDirective,
  ],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  public readonly showLogin = input<boolean>(false);
  public readonly includeTopPadding = input<boolean>(true);

  private readonly userService = inject(UserService);
  private readonly authService = inject(AuthService);

  protected readonly user = this.userService.user;

  protected readonly footerLinks = computed<{ label: string; link: string[] }[]>(() => ([
    { label: 'How it works',      link: ['/how-it-works'] },
    { label: 'Common questions', link: ['/common-questions'] },
    { label: 'About us',         link: ['/about-us'] },
    { label: 'Contact us',       link: ['/contact'] },
    { label: 'Articles',        link: ['/articles'] },
    { label: 'Privacy',         link: ['/privacy-policy'] },
    { label: 'Terms & Conditions',           link: ['/terms-and-conditions'] },
    { label: 'All apartments',   link: ['/apartments'] },
  ]));

  onLogoutClick() {
    this.authService.logout();
  }

  protected readonly isNative = isNative;
}
